module.exports = __webpack_public_path__ + "media/images/area/icon_weather_27-6641b905f23229d9047fcd720b2c0786.png";